import React from 'react';
import { AppNextLink } from '@/features/app-next-link';
import { IconCallCalling } from '@/features/icons';
import { primaryPhoneNumber, secondaryPhoneNumber } from '@/app/_constants/brand-contact';
function SupportDetails() {
  return <div className='flex w-full flex-col items-center gap-2' data-sentry-component="SupportDetails" data-sentry-source-file="support-details.tsx">
            <span className='text-center text-sm text-white'>
                روزهای شنبه تا پنجشنبه، از ساعت 9 الی 21 پاسخگوی سوالات شما هستیم.
            </span>
            <div className='divide mt-1 flex items-center gap-3 divide-x divide-x-reverse divide-text-darkGray text-sm text-text-lightGray'>
                <AppNextLink href={`tel:${primaryPhoneNumber.value}`} className='flex items-center gap-1' data-sentry-element="AppNextLink" data-sentry-source-file="support-details.tsx">
                    <IconCallCalling className='h-5 w-5 rounded-full bg-primary-main p-1 text-white' data-sentry-element="IconCallCalling" data-sentry-source-file="support-details.tsx" />
                    {primaryPhoneNumber.value}
                </AppNextLink>
                <AppNextLink href={`tel:${secondaryPhoneNumber.value}`} className='flex items-center gap-1 pr-3' data-sentry-element="AppNextLink" data-sentry-source-file="support-details.tsx">
                    <IconCallCalling className='h-5 w-5 rounded-full bg-primary-main p-1 text-white' data-sentry-element="IconCallCalling" data-sentry-source-file="support-details.tsx" />
                    {secondaryPhoneNumber.value}
                </AppNextLink>
            </div>
        </div>;
}
export default SupportDetails;